import { DataTableColumnHeader } from "@/components/DataTable/Columns/DataTableColumnHeader";
import { AppUserActionButton } from "@/features/app-user/components/SuggestedActionColumn/AppUserActionButton";
import type { AppUserAction } from "@/features/app-user/types";
import { useQueryClient } from "@tanstack/react-query";
import type { CellContext, ColumnDef } from "@tanstack/table-core";

type AppUserActionColumnProps = {
  appIntegration: {
    appIntegrationId: string;
  };
  user?: {
    id: string;
  };
  person?: {
    id: string;
  };
  app: {
    name: string;
  };
  action?: {
    type: "CREATE" | "DEACTIVATE" | "REACTIVATE";
    disabled: boolean;
    describe?: string;
  };
};

export function AppUserPrimaryActionColumn<
  T extends AppUserActionColumnProps,
>() {
  const queryClient = useQueryClient();

  return {
    id: "primary-action",
    accessorKey: "primary-action",
    enableSorting: false,
    meta: { i18nKey: "action" as const },
    header: (props) => <DataTableColumnHeader {...props} />,
    cell: ({ row: { original } }: CellContext<T, unknown>) => {
      const { appIntegration, user, person, app, action } = original;

      if (!action) {
        return "-";
      }

      return (
        <AppUserActionButton
          appIntegrationId={appIntegration.appIntegrationId}
          appUserId={user?.id}
          personId={person?.id}
          appName={app.name}
          action={action as AppUserAction}
          onSuccess={() => {
            queryClient.invalidateQueries({
              queryKey: ["alerts"],
            });
          }}
        />
      );
    },
  } satisfies ColumnDef<T>;
}
